export const IFRAME_ID = 'stat-attack';
export const WIDGET_ID = 'STAT_ATTACK';
export const WIDGET_MODAL = 'widget-modal-SA';
export const SPINNER_ID = 'sa-spinner';
export const SPINNER_WRAPPER_ID = 'sa-spinner-wrapper';
export const IFRAME_SOURCE_ID = 'stat-attack';
export const MESSAGE_EVENT_TYPE = 'message';
export const IFRAME_ACTION_NAVIGATE = 'navigate';
export const IFRAME_ACTION_OPEN = 'open';
export const IFRAME_ACTION_CLOSE = 'close';
export const IFRAME_ACTION_ADDTOSLIP = 'addToSlip';
export const IFRAME_ACTION_ADDTOSLIP_BYO = 'addToSlipBYO';
export const IFRAME_ACTION_ANALYTICS = 'analytics';
export const ADDTOSLIP_HOME_PAGE = 'addToSlipHomepage';
export const EVENT_PAGE = 'event';
export const HOME_PAGE = 'home';
export const DML_PAGE = 'dml';
export const SPORTCALLER_ANALYTICS_EVENT = 'sport_caller';
export const PAGEVIEW_ANALYTICS_EVENT = 'pageview';
export const MODAL = 'xs-modal';
export const MODAL_OPEN = 'xs-modal--open';
export const FOOTBALL = 'football';
